import React from "react";
import { renderRoutes } from "react-router-config";
import Admin from "../Components/Admin/Admin";
import DashBoardReports from "../Components/Dashboard/DashboardReports";
import TenantDashBoard from "../Components/Dashboard/TenantDynamicDashboard";
import SuperAdminHeader from "../Components/SuperAdmin/SuperAdminHeader";
import SuperAdminTenantCretion from "../Components/SuperAdmin/SuperAdminTenantCretion";
import SuperAdminTenantRemove from "../Components/SuperAdmin/SuperAdminTenantRemove";
import AddRisks from "../Components/Tenant/AddRisk";
import AddUserControl from "../Components/Tenant/AddUserControl";
import Cart from "../Components/Tenant/Cart";
import Documents from "../Components/Tenant/Documents";
import TenantElivation from "../Components/Tenant/ElivatedRiskManagement";
import ImpactsList from "../Components/Tenant/ImpactsList";
import { ImportData } from "../Components/Tenant/ImportData";
import Datasets from "../Components/Tenant/Datasets";
import { MonteCarlo } from "../Components/Tenant/MonteCarlo";
import OrganizationUnit from "../Components/Tenant/OrganizationalUnit";
import ProjectHome from "../Components/Tenant/ProjectHome";
import RiskDashboard from "../Components/Tenant/RiskDashboard";
import Scenario from '../Components/Tenant/Scenario';
import TenantCreateUserForm from "../Components/Tenant/TenantCreateUserForm";
import TenantCreateUsers from "../Components/Tenant/TenantCreateUsers";
import TenantHeader from "../Components/Tenant/TenantHeader";
import UserDashBoard from "../Components/User/UserDashBoard";
import EmailVerification from "../Components/verify/EmailVerification";
import ChangePassword from "../Screens/ChangePassword";
import ForgotPassword from "../Screens/ForgotPassword";
import Login from "../Screens/Login";
import PageNotFound from "../Screens/PageNotFound";
import ResetPassword from "../Screens/ResetPassword";
import UnAuthorized from "../Screens/UnAuthorized";
import UserHeader from "../Screens/User/UserHeader";
import ImpactTemplate from "../Components/Tenant/Component/ImpactTemplate";
import TaskModule from "../Components/Tenant/TaskModule";
import TaskRegister from "../Components/Tenant/TaskRegister";

const root = ({ route }) => {
 
  return <div>{renderRoutes(route.routes)}</div>;
 
};



export const RoutesPath = [
  {
    component: Login,
    path: process.env.PUBLIC_URL + "/",
    exact: true,
  },
  {
    component: root,
    path: process.env.PUBLIC_URL + "/",
    routes: [
      {
        component: Login,
        path: process.env.PUBLIC_URL + "/",
        exact: true,
      },
      {
        component: Login,
        path: process.env.PUBLIC_URL + "/login",
        exact: true,
      },
      
      {
        component: PageNotFound,
        path: process.env.PUBLIC_URL + "/pagenotfound",
        exact: true,
      },
      {
        component: ForgotPassword,
        path: process.env.PUBLIC_URL + "/:id/forgotPassword",
        exact: true,
      },
      {
        component: SuperAdminHeader,
        path: process.env.PUBLIC_URL + "/superadmin/home",
      },
      {
        component: SuperAdminTenantCretion,
        path: process.env.PUBLIC_URL + "/superadmin/home/Add",
        exact: true,
      },
      {
        component: SuperAdminTenantRemove,
        path: process.env.PUBLIC_URL + "/superadmin/home/Remove",
        exact: true,
      },
      //TenantRoutes
      {
        component: Login,
        path: process.env.PUBLIC_URL + "/tenant/:id",
        exact: true,
      },
      {
        component: UnAuthorized,
        path: process.env.PUBLIC_URL + "/tenant/:id/unauthorized",
        exact: true,
      },
      {
        component: EmailVerification,
        path: process.env.PUBLIC_URL + "/user/:id/emailverification/:salt",
        exact: true,
      },
      {
        component: ResetPassword,
        path: process.env.PUBLIC_URL + "/tenant/:id/resetpassword/:token",
        exact: true,
      },
      {
        component: ResetPassword,
        path: process.env.PUBLIC_URL + "/user/:id/resetpassword/:token",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home",
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/taskmodule",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/prime",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/users",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/users/add",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/dashboard",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/dashboard/reports",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/main",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/elivation",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/impacts",
        exact: true,
      },
     
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/scenario",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/datasets",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/admin",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/addusercontrol",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/impacts/add",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/documents/:type/:id",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/addrisks",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/cart",
        exact: true,
      },
      
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/quadrantrisks",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/import",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/reports",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/riskdashboard",
        exact: true,
      },
      {
        component: TenantHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/unit",
        exact: true,
      },
      {
        component: ChangePassword,
        path: process.env.PUBLIC_URL + "/tenant/:id/changepassword",
        exact: true,
      },
      //User Routes
      {
        component: Login,
        path: process.env.PUBLIC_URL + "/user/:id",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard",
        exact: true,
      },
      {
        component: UserHeader,
        path:
          process.env.PUBLIC_URL + "/user/:id/home/dashboard/changepassword",
        exact: true,
      },
      //new user routes
      {
        component: UnAuthorized,
        path: process.env.PUBLIC_URL + "/user/:id/unauthorized",
        exact: true,
      },
       {
        component: EmailVerification,
        path: process.env.PUBLIC_URL + "/user/:id/emailverification/:salt",
        exact: true,
      },
      {
        component: ResetPassword,
        path: process.env.PUBLIC_URL + "/user/:id/resetpassword/:token",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home",
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/taskmodule",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/prime",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/users",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/users/add",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard/reports",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/main",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/elivation",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/impacts",
        exact: true,
      },
      
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/datasets",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/admin",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/impacts/add",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/documents/:type/:id",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/addrisks",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/Cart",
        exact: true,
      },
      
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/import",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/reports",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/riskdashboard",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/unit",
        exact: true,
      },
      {
        component: ChangePassword,
        path: process.env.PUBLIC_URL + "/user/:id/changepassword",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/scenario",
        exact: true,
      },
      {
        component: UserHeader,
        path: process.env.PUBLIC_URL + "/user/:id/home/quadrantrisks",
        exact: true,
      },
    ],
  },
];

export const UserLoginRoute = [
  {
    component: root,
    path: process.env.PUBLIC_URL + "/user/:id/home",
    routes: [
      {
        component: UserDashBoard,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard",
        exact: true,
      },
      {
        component: ChangePassword,
        path:
          process.env.PUBLIC_URL + "/user/:id/home/dashboard/changepassword",
        exact: true,
      },
      //new
      {
        component: TenantCreateUsers,
        path: process.env.PUBLIC_URL + "/user/:id/home/users",
        exact: true,
      },
      {
        component: TenantCreateUserForm,
        path: process.env.PUBLIC_URL + "/user/:id/home/users/add",
        exact: true,
      },
      {
        component: TenantDashBoard,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard",
        exact: true,
      },
      {
        component: DashBoardReports,
        path: process.env.PUBLIC_URL + "/user/:id/home/dashboard/reports",
        exact: true,
      },
      {
        component: TenantElivation,
        path: process.env.PUBLIC_URL + "/user/:id/home/elivation",
        exact: true,
      },
      {
        component: ImpactsList,
        path: process.env.PUBLIC_URL + "/user/:id/home/impacts",
        exact: true,
      },
      
      {
        component: Datasets,
        path: process.env.PUBLIC_URL + "/user/:id/home/datasets",
        exact: true,
      },
      {
        component: Admin,
        path: process.env.PUBLIC_URL + "/user/:id/home/admin",
        exact: true,
      },
      {
        component: Admin,
        path: process.env.PUBLIC_URL + "/user/:id/home/admin",
        exact: true,
      },
      {
        component: AddUserControl,
        path: process.env.PUBLIC_URL + "/user/:id/home/addusercontrol",
        exact: true,
      },
    
      
      {
        component: AddRisks,
        path: process.env.PUBLIC_URL + "/user/:id/home/addrisks",
        exact: true,
      },
      {
        component: Cart,
        path: process.env.PUBLIC_URL + "/user/:id/home/cart",
        exact: true,
      },
      
      {
        component: MonteCarlo,
        path: process.env.PUBLIC_URL + "/user/:id/home/monteCarlo",
        exact: true,
      },
      {
        component: ImpactTemplate,
        path: process.env.PUBLIC_URL + "/user/:id/home/prime",
        exact: true,
      },
      {
        component: TaskModule,
        path: process.env.PUBLIC_URL + "/user/:id/home/taskmodule",
        exact: true,
      },
      {
        component: ImportData,
        path: process.env.PUBLIC_URL + "/user/:id/home/import",
        exact: true,
      },
      {
        component: Documents,
        path: process.env.PUBLIC_URL + "/user/:id/home/documents/:type/:id",
        exact: true,
      },
      {
        component: ProjectHome,
        path: process.env.PUBLIC_URL + "/user/:id/home/main",
        exact: true,
      },
      {
        component: RiskDashboard,
        path:
          process.env.PUBLIC_URL +
          "/user/:id/home/riskdashboard/:organizationUnitId",
        exact: true,
      },
      {
        component: TaskRegister,
        path:
          process.env.PUBLIC_URL +
          "/user/:id/home/taskregister/:taskId",
        exact: true,
      },
      {
        component: OrganizationUnit,
        path: process.env.PUBLIC_URL + "/user/:id/home/unit",
        exact: true,
      },
      {
        component: Scenario,
        path: process.env.PUBLIC_URL + "/user/:id/home/scenario",
        exact: true,
      },
       {
    // Catch-all route for 404 — no path needed
    component: PageNotFound,
  },
    ],
  },
];

export const TenantAdminRoute = [
  {
    component: root,
    path: process.env.PUBLIC_URL + "/tenant/:id/home",
    routes: [
      {
        component: TenantCreateUsers,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/users",
        exact: true,
      },
      {
        component: TenantCreateUserForm,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/users/add",
        exact: true,
      },
      {
        component: TenantDashBoard,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/dashboard",
        exact: true,
      },
      {
        component: DashBoardReports,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/dashboard/reports",
        exact: true,
      },
      {
        component: TenantElivation,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/elivation",
        exact: true,
      },
      {
        component: ImpactsList,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/impacts",
        exact: true,
      },
      
      {
        component: Scenario,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/scenario",
        exact: true,
      },
      {
        component: Datasets,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/datasets",
        exact: true,
      },
      {
        component: Admin,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/admin",
        exact: true,
      },
      {
        component: ImpactTemplate,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/prime",
        exact: true,
      },
      {
        component: TaskModule,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/taskmodule",
        exact: true,
      },
      {
        component: AddRisks,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/addrisks",
        exact: true,
      },
      {
        component: Cart,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/cart",
        exact: true,
      },
      
      
      {
        component: MonteCarlo,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/monteCarlo",
        exact: true,
      },
      {
        component: ImportData,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/import",
        exact: true,
      },
      {
        component: Documents,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/documents/:type/:id",
        exact: true,
      },
      {
        component: ProjectHome,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/main",
        exact: true,
      },
      {
        component: RiskDashboard,
        path:
          process.env.PUBLIC_URL +
          "/tenant/:id/home/riskdashboard/:organizationUnitId",
        exact: true,
      },
      {
        component: TaskRegister,
        path:
          process.env.PUBLIC_URL +
          "/tenant/:id/home/taskregister/:taskId",
        exact: true,
      },
      {
        component: OrganizationUnit,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/unit",
        exact: true,
      },
      {
        component: AddUserControl,
        path: process.env.PUBLIC_URL + "/tenant/:id/home/addusercontrol",
        exact: true,
      },
       {
    // Catch-all route for 404 — no path needed
    component: PageNotFound,
  },
    ],
  },
];

export const superAdminDashboardRoute = [
  {
    component: root,
    path: process.env.PUBLIC_URL + "/superadmin/home",
    routes: [
      {
        component: SuperAdminTenantCretion,
        path: process.env.PUBLIC_URL + "/superadmin/home/Add",
        exact: true,
      },
      {
        component: SuperAdminTenantRemove,
        path: process.env.PUBLIC_URL + "/superadmin/home/Remove",
        exact: true,
      },
    ],
  },
];

// Create a NotFoundRedirect component that will handle unknown routes
const NotFoundRedirect = ({ route }) => {
  window.location.href = process.env.PUBLIC_URL + "/pagenotfound";
  return null;
};

// Add this route to both TenantAdminRoute and UserLoginRoute
const notFoundRoute = {
  component: NotFoundRedirect,
  path: process.env.PUBLIC_URL + "/:clientType/:id/home/main/routingTest",
  exact: true,
};

// Add the notFoundRoute to TenantAdminRoute
TenantAdminRoute[0].routes.push(notFoundRoute);

// Add the notFoundRoute to UserLoginRoute
UserLoginRoute[0].routes.push(notFoundRoute);
